module.exports = __webpack_public_path__ + "assets/img/zyxt_img.114aad4a.png";